var map = {
	"./dataSet0.png": "AieN",
	"./dataSet1.png": "/CzY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vWty";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/dataSet.*\.png$
// module id = vWty
// module chunks = 3